import React, { Component } from 'react';
import { Slider } from '@material-ui/lab';
import { Checkbox, FormControlLabel, Typography, TextField } from '@material-ui/core';
import ReactPlayer from 'react-player';
import { beautifySec } from '../../../utils';
import './Tuning.scss';

class Video extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timeToComplete: props.slide.itemToComplete || 180,
      description: (props.slide.item && props.slide.item.description) || '',
      title: (props.slide.item && props.slide.item.title) || '',
      canBeRewound: (props.slide.item && props.slide.item.canBeRewound) || false,
      videoUrl: (props.slide.item && (props.slide.item.videoUrl || props.slide.item.youTubeVideo)) || '',
    };
  }

  // Проверка ссылки (учитываем RuTube и VK)
  checkIfPlayable = (url) => {
    if (!url) return false;

    // Проверяем наличие доменов ИЛИ наших префиксов из базы
    var isRussian = url.indexOf('rutube.ru') !== -1 || 
                    url.indexOf('vk.com') !== -1 || 
                    url.indexOf('vkvideo.ru') !== -1 ||
                    url.indexOf('rt_') === 0 || // Если пришло rt_ из базы
                    url.indexOf('vk_') === 0;   // Если пришло vk_ из базы

    // Важно: ReactPlayer.canPlay часто выдает false для VK/RuTube, 
    // поэтому мы доверяем нашей переменной isRussian
    return isRussian || ReactPlayer.canPlay(url);
  }

  // Метод для синхронизации данных с родителем (Slide.jsx)
 syncData = (newState) => {
    // 1. Достаем item, id и self без использования оператора ?.
    const item = (this.props.slide && this.props.slide.item) || this.props.slide;
    const slideId = item && item.id;
    const slideSelf = item && item.self; 

       // Выводим в консоль для отладки
    console.log("DEBUG: slideSelf =", slideSelf);
    console.log("DEBUG: slideId =", slideId);

    // 2. Логика ID для видео (VK/RuTube)
    let backendVideoId = newState.videoUrl;
    if (newState.videoUrl.indexOf('vk.com') !== -1 || newState.videoUrl.indexOf('vkvideo.ru') !== -1) {
      const match = newState.videoUrl.match(/video(-?\d+)_(\d+)/);
      if (match) {
        backendVideoId = "vk_" + match[1] + "_" + match[2];
      }
    } else if (newState.videoUrl.indexOf('rutube.ru') !== -1) {
      const parts = newState.videoUrl.split('/').filter(Boolean);
      const lastPart = parts[parts.length - 1].split('?')[0];
      backendVideoId = "rt_" + lastPart;
    }

    // 3. Формируем объект для сохранения
    const dataToSave = {
      ...item, // Разворачиваем старый объект, чтобы сохранить все системные поля
      title: newState.title,
      description: newState.description,
      timeToComplete: newState.timeToComplete,
      canBeRewound: newState.canBeRewound,
      videoUrl: newState.videoUrl,    
      type: 'youtube_video',         
      youTubeVideo: backendVideoId 
    };

    // 4. Валидация
    const isPlayable = this.checkIfPlayable(newState.videoUrl);
    const valid = 
      newState.title.trim() !== '' && 
      newState.description.trim() !== '' && 
      isPlayable;
    
    this.props.setValidSlide(valid);
    
    if (this.props.onEdit) {
      this.props.onEdit(dataToSave, this.props.index);
    } 
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value }, () => {
      this.syncData(this.state);
    });
  };

  handleSliderChange = (name, value) => {
    this.setState({ [name]: value }, () => {
      this.syncData(this.state);
    });
  };

  handleChangeCheckbox = (e) => {
    const { name, checked } = e.target;
    this.setState({ [name]: checked }, () => {
      this.syncData(this.state);
    });
  };

  
  renderPlayer = (url) => {
      if (!url) return null; 
      // 2. ОБРАБОТКА RUTUBE
      if (url.indexOf('rutube.ru') !== -1 || url.indexOf('rt_') === 0) {
        var videoId = '';
        
        if (url.indexOf('rt_') === 0) {
          videoId = url.replace('rt_', ''); 
        } else {
          var parts = url.split('/').filter(Boolean);
          var lastPart = parts[parts.length - 1];
          videoId = lastPart.split('?')[0];
        }

        // ПРАВИЛЬНЫЙ ПУТЬ: /play/embed/
        const finalUrl = `https://rutube.ru/play/embed/${videoId}/`;
    
        return (
          <iframe 
            src={finalUrl} 
            width="100%" height="420" 
            frameBorder="0" allowFullScreen 
            style={{ border: 'none' }}
          />
        );
      }

      // 3. YouTube и другие
      return <ReactPlayer url={url} width="100%" height="650px" controls={true} />;
  }

  render() {
    const { canBeRewound, videoUrl, timeToComplete, title, description } = this.state;
    const { isInvalidInput } = this.props;
    const isPlayable = this.checkIfPlayable(videoUrl);

    return (
      <div className="slideContent">
        <div className="slidesSidebar">
          <Typography id="slider-image">Ссылка на видео (RuTube)</Typography>
          <TextField
            className="text" name="videoUrl" value={videoUrl}
            label="Вставьте URL"
            error={(videoUrl && !isPlayable) || (!videoUrl && isInvalidInput)}
            onChange={this.handleChange} fullWidth
          />
        </div>

        <div className="mainField">
          <div className="contentWrapper" style={{ padding: '10px' }}>
            <div className="videoDescription" style={{ padding: '10px', width: '100%' }}>
              <TextField name="title" value={title} label="Название" fullWidth onChange={this.handleChange} error={!title && isInvalidInput} />
              <TextField name="description" value={description} label="Описание" fullWidth multiline onChange={this.handleChange} error={!description && isInvalidInput} />
            </div>
           <div className="player-preview"  style={{ 
                    position: 'relative', 
                    width: '60%', 
                    textAlign: 'center', 
                    height: '480',
              }}>
              {videoUrl && isPlayable ? this.renderPlayer(videoUrl) : (
                <div style={{ color: '#fff', textAlign: 'center', height: '360px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#333' }}>
                  Ожидание ссылки...
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Video;